import {useNavigate, useParams} from 'react-router-dom';
import cardSpotImg from '../../../../assets/image/lendTech/cardSpotImg.jpg';
import Button from '../../../../components/button';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import ChatHeaderIcon from '../../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useGetTakenDirectLoanDetails from '../../../../services/hookService/getTakenDirectLoanDetails/useGetTakenDirectLoanDetails';
import {getPersianDateTimeV2} from '../../../../utilities/helper/GetPersianDateTime/index';
import StatsGrid from '../../cashBack/components/StatsGrid';

const BankPaymentDetail = () => {
  const navigate = useNavigate();
  const {loanGuid} = useParams();

  const {data, isLoading} = useGetTakenDirectLoanDetails(loanGuid);

  const stats = [
    {
      title: 'کل اعتبار دریافت شده',
      value: data?.total_balance?.toLocaleString(),
      show: true,
      isPrice: true,
    },
    {
      title: 'اعتبار استفاده شده',
      value: '0',
      show: true,
      isPrice: true,
    },
  ];

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      {/* Header */}
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2 cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">اعتبار من</span>
          </div>
        )}
        postComponent={() => (
          <div className="flex gap-3 ">
            <NotificationHeaderIcon />
            <ChatHeaderIcon />
          </div>
        )}
      />

      {/* Content */}
      <div className="flex flex-col w-full h-full gap-3 p-[1.5rem] overflow-y-auto">
        {isLoading && (
          <div className="grid h-dvh place-content-center">
            <SpinnerLoading />
          </div>
        )}

        {!isLoading && (
          <>
            <section className="flex flex-col gap-[1.5rem]  text-sm rounded-[20px]">
              <div className="relative w-full overflow-hidden rounded-lg bg-[#F5FBEE] p-[1.5rem]">
                <img
                  src={cardSpotImg}
                  alt=""
                  className="absolute top-0 right-0 object-contain w-auto h-full"
                  style={{mixBlendMode: 'multiply'}}
                />

                <div className="flex flex-col gap-4">
                  <span className="text-sm font-medium text-right">
                    اعتبار باقی مانده
                  </span>
                  <span className="text-xl font-bold text-center">
                    {data?.total_balance?.toLocaleString() + ' تومان'}
                  </span>
                  <div className="flex justify-end gap-2 text-sm">
                    <span>انقضا</span>
                    <span>{getPersianDateTimeV2(data?.expire_date)}</span>
                  </div>
                </div>
              </div>

              <StatsGrid stats={stats} />

              <div className="flex gap-1 mt-6">
                <i className="text-lg icon-warning-triangle text-[#DC6803]" />
                <span className="text-[#DC6803]">
                  بازپرداخت این اعتبار در اپلکیشن بانک ارائه دهنده وام انجام
                  میشود.
                </span>
              </div>
              <div className="fixed left-0 right-0 z-50 bottom-0 !bg-white shadow-[0_-1px_6px_0_rgba(0,0,0,0.1)]">
                <div className="p-3">
                  <Button
                    type="button"
                    className="w-full"
                    onClick={() => navigate('/home')}
                  >
                    خرید از فروشگاه
                  </Button>
                </div>
                <MainFooter isScrolling={false} />
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default BankPaymentDetail;
